export class ScheduleExceptionDTO {

    constructor(
        public id: string,
        public startDate: string,
        public endDate: string,
        public description: string | null
    ) { }
}
